'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Group) {
  _inherits(_class, _Phaser$Group);

  function _class(_ref) {
    var game = _ref.game,
        lineCount = _ref.lineCount,
        lineCharWidth = _ref.lineCharWidth;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game));

    _this.lineCharWidth = lineCharWidth;

    _this.lines = [];

    for (var i = 0; i < lineCount; i++) {
      var y = i * 23;

      var line = game.add.text(0, y, '', {
        font: '20px Courier New',
        fill: '#00FFEA',
        smoothed: false
      }, _this);

      _this.lines.push(line);
    }

    _this.charBuffer = [];

    _this.charFrameDelay = 0;
    _this.charFrameDelayCount = 0;

    _this.onBufferEmptySignal = new _phaser2.default.Signal();
    return _this;
  }

  _createClass(_class, [{
    key: 'update',
    value: function update() {
      if (!this.visible || this.charBuffer.length == 0) {
        return;
      }

      if (this.charFrameDelayCount > 0) {
        this.charFrameDelayCount--;
        return;
      }

      this.charFrameDelayCount = this.charFrameDelay;

      var lastLine = this.lastLine();
      var nextChar = this.charBuffer.shift();

      if (nextChar == "\n") {
        this.shiftLines();

        this.charFrameDelayCount += 10;
      } else {
        lastLine.text = lastLine.text + nextChar;

        if (lastLine.text.length == this.lineCharWidth) {
          this.shiftLines();
        }
      }

      if (this.charBuffer.length == 0) {
        this.onBufferEmptySignal.dispatch();
      }
    }
  }, {
    key: 'addText',
    value: function addText(text) {
      this.charBuffer = this.charBuffer.concat(text.split(''));
    }
  }, {
    key: 'clearText',
    value: function clearText() {
      this.lines.forEach(function (line) {
        line.text = '';
      });

      this.charBuffer = [];
    }
  }, {
    key: 'shiftLines',
    value: function shiftLines() {
      for (var i = 0; i < this.lines.length - 1; i++) {
        this.lines[i].text = this.lines[i + 1].text;
      }
      this.lastLine().text = "";
    }
  }, {
    key: 'lastLine',
    value: function lastLine() {
      return this.lines[this.lines.length - 1];
    }
  }, {
    key: 'setCharFrameDelay',
    value: function setCharFrameDelay(value) {
      this.charFrameDelay = value;
      this.charFrameDelayCount = value;
    }
  }]);

  return _class;
}(_phaser2.default.Group);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/ui/Terminal.js
// module id = 370
// module chunks = 0